import ACTIONS from '@/libs/signalR/vuexStore/storeActions';
import { ConnectionStatus, RunStates } from '@/libs/signalR/vuexStore/store/state';

const mutations = {
  [ACTIONS.SIGNAL_R__SET_HUB_TOKEN]: (state, payload) => {
    state.hubToken = payload
  },
  [ACTIONS.SIGNAL_R__SET_RUN_STATE]: (state, payload) => {
    state.runState = payload;
  },
  [ACTIONS.SIGNAL_R__HANDLE_CONNECT_EVENT]: (state, payload) => {
    state.connectionStatus = payload.eventType
  },
  [ACTIONS.SIGNAL_R__HANDLE_CHANGE_EVENT]: (state, payload) => {
    // Client behaviour based on eventType
    /**
     * @eventType RunFinished - Clients actively disconnect from hub
     * @eventType RunEdit - Clients go into blocking mode - connection to hub is kept alive
     * @eventType RunStarted - Clients leave blocking mode - connection to hub is kept alive
     * @eventType RunConference - Clients stay in active mode - connection to hub is kept alive
     */
    switch (payload.eventType) {
      case RunStates.RunFinished:
        state.connectionStatus = ConnectionStatus.ClientDisconnected
        state.runState = payload.eventType;
        return;
      default:
        state.runState = payload.eventType;
    }
  }
}

export default mutations
